// API related actions
export const FETCHING_CALENDAR_TEMS = '@@toyota/FETCHING_CALENDAR_TEMS';
export const FETCHED_CALENDAR_TEMS = '@@toyota/FETCHED_CALENDAR_TEMS';
export const FETCHED_CALENDAR_TEMS_FAILED = '@@toyota/FETCHED_CALENDAR_TEMS_FAILED';
export const FETCHING_CALENDAR_DETAIL_TEMS = '@@toyota/FETCHING_CALENDAR_DETAIL_TEMS';
export const FETCHED_CALENDAR_DETAIL_TEMS = '@@toyota/FETCHED_CALENDAR_DETAIL_TEMS';
export const FETCHED_CALENDAR_DETAIL_TEMS_FAILED = '@@toyota/FETCHED_CALENDAR_DETAIL_TEMS_FAILED';
export const UPDATED_DATE_CALENDAR_TEMS = '@@toyota/UPDATED_DATE_CALENDAR_TEMS';
export const UPDATE_DATE_CALENDAR_TEMS = '@@toyota/UPDATE_DATE_CALENDAR_TEMS';
export const UPDATED_DATE_CALENDAR_TEMS_FAILED = '@@toyota/UPDATED_DATE_CALENDAR_TEMS_FAILED';

